import { COLOR_MODE } from '@ouster/webviz';

// WINDOW is a custom channel (not part of the @ouster/webviz COLOR_MODE enum
// yet) that the SDK always renders with AE/autolevel disabled - see
// SensorModel._create_view_mode_for_field in the SDK's viz/model.py.
export const WINDOW_CHANNEL_FIELD = 'WINDOW';

export function isReflectivityColorMode(
  coloringMode: COLOR_MODE | string | undefined | null
): boolean {
  return (
    typeof coloringMode === 'string' &&
    coloringMode.startsWith(COLOR_MODE.REFLECTIVITY)
  );
}

export function isWindowColorMode(
  coloringMode: COLOR_MODE | string | undefined | null
): boolean {
  return coloringMode === WINDOW_CHANNEL_FIELD;
}

export function isRgbColorMode({
  coloringMode,
  rgbChannels,
}: {
  coloringMode: COLOR_MODE | string;
  rgbChannels: string[];
}): boolean {
  return rgbChannels.includes(coloringMode);
}

export function shouldDisableAutoLevelsForMode({
  coloringMode,
  colorPalette,
}: {
  coloringMode: COLOR_MODE | string;
  colorPalette: string;
  rgbChannels: string[];
}): boolean {
  return (
    (isReflectivityColorMode(coloringMode) && colorPalette === 'CalRef') ||
    isWindowColorMode(coloringMode)
  );
}
